/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CharGroups {
    LowerCase = 1,
    UpperCase = 2,
    NumberCase = 4,
}
